<template>
    <div class="content">
        <base-header class="pb-6">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h6 class="h2 text-white d-inline-block mb-0">
                        {{ $t("report_by_user") }}
                    </h6>
                    <nav
                        aria-label="breadcrumb"
                        class="d-none d-md-inline-block ml-md-4"
                    >
                        <route-bread-crumb></route-bread-crumb>
                    </nav>
                </div>
            </div>
        </base-header>
        <div class="container-fluid mt--6">
            <div>
                <card
                    class="no-border-card"
                    body-classes="px-0 pb-1"
                    footer-classes="pb-2"
                >
                    <template slot="header">
                        <div class="row">
                            <div class="col-md-2">
                                <base-input>
                                    <flat-picker
                                        slot-scope="{ focus, blur }"
                                        @on-open="focus"
                                        @on-close="blur"
                                        :config="{ allowInput: true }"
                                        class="form-control datepicker"
                                        v-model="startDate"
                                    >
                                    </flat-picker>
                                </base-input>
                            </div>

                            <div class="col-md-2">
                                <base-input>
                                    <flat-picker
                                        slot-scope="{ focus, blur }"
                                        @on-open="focus"
                                        @on-close="blur"
                                        :config="{ allowInput: true }"
                                        class="form-control datepicker"
                                        v-model="endDate"
                                    >
                                    </flat-picker>
                                </base-input>
                            </div>

                            <div class="col-md-2">
                                <base-input>
                                    <el-select
                                        v-model="paymentMethodType"
                                        :placeholder="$t('payment_method_type')"
                                        filterable
                                    >
                                        <el-option
                                            v-for="option in PaymentMethodTypeTable"
                                            :key="option.id"
                                            :label="option.name"
                                            :value="option.id"
                                        >
                                        </el-option>
                                    </el-select>
                                </base-input>
                            </div>

                            <div class="col-md-2">
                                <base-input>
                                    <el-select
                                        v-model="orderStatus"
                                        :placeholder="$t('menu.order_status')"
                                        filterable
                                    >
                                        <el-option
                                            v-for="option in OrderStatusTable"
                                            :key="option.ID"
                                            :label="option.Name"
                                            :value="option.ID"
                                        >
                                        </el-option>
                                    </el-select>
                                </base-input>
                            </div>

							<div class="col-md-2">
								<base-input  >
								<el-select v-model="saleChannelType" :placeholder="$t('sale_channel')" filterable >
									<el-option
										v-for="option in SaleChannelTypeTableWithAll"
										:key="option.id"
										:label="option.name"
										:value="option.id"
									>
									</el-option>
								</el-select>
							</base-input>
                            </div>

							<div class="col-md-2">
                                <base-input>
                                    <el-select
                                        v-model="userId"
                                        :placeholder="$t('menu.user')"
                                        filterable
                                    >
                                        <el-option
                                            v-for="option in OptionUserTable"
                                            :key="option.UserID"
                                            :label="option.fname + ' ' + option.lname"
                                            :value="option.UserID"
                                        >
                                        </el-option>
                                    </el-select>
                                </base-input>
                            </div>

                            <div class="col-auto">
                                <base-button
                                    size="md"
                                    type="primary"
                                    @click="handleSearch()"
                                >
                                    Search
                                </base-button>
                                <base-button
                                    size="md"
                                    type="primary"
                                    @click="handleDownloadXLSX()"
                                >
                                    Export
                                </base-button>
                            </div>
                        </div>
                    </template>
                    <div>
						<div class="row">
							<div class="col ml-4" v-if="reportDatum != 0">
								รวม : {{ FormatCurrency(reportDatum)}}
							</div>

						</div>
                        <el-table
                            :data="queriedData"
                            row-key="id"
                            header-row-class-name="thead-light"
                            @sort-change="sortChange"
                            @selection-change="selectionChange"
                        >
                            <el-table-column
                                v-for="column in tableColumns"
                                :key="column.label"
                                v-bind="column"
                            >
                            </el-table-column>

                            <!-- <el-table-column
				  min-width="200px"
				  align="right"
				  :label="$t('actions')"
				>
				  <div slot-scope="{ $index, row }" class="d-flex">
					<base-button
					  @click.native="handleDetail($index, row)"
					  class="edit"
					  type="warning"
					  size="sm"
					  icon
					>
					  <i class="text-dtac-bt fa fa-edit"></i>
					  Detail
					</base-button>
				  </div>
				</el-table-column> -->
                        </el-table>
                    </div>
                    <div
                        slot="footer"
                        class=" col-12 d-flex justify-content-center justify-content-sm-between flex-wrap "
                        v-if="queriedData.length != 0"
                    >
                        <div class="">
                            <p class="card-category">
                                {{ $t("data") }} {{ from + 1 }} {{ $t("to") }}
                                {{ to }}
                                {{ $t("of") }}
                                {{ total }}
                                <span v-if="selectedRows.length">
                                    - &nbsp; &nbsp; {{ selectedRows.length }}
                                    {{ $t("row_select") }}
                                </span>
                            </p>
                        </div>
                        <base-pagination
                            class="pagination-no-border"
                            v-model="pagination.currentPage"
                            :per-page="pagination.perPage"
                            :total="total"
                        >
                        </base-pagination>
                    </div>
                </card>
            </div>
        </div>
    </div>
</template>
<script>

import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "../PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moment from "moment";
import { read, utils, writeFile } from 'xlsx'

export default {
    mixins: [clientPaginationMixin],
    components: {
        flatPicker,
        BasePagination,
        RouteBreadCrumb,
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn
    },
    computed: {
        ...mapGetters({
            tableData: "Report/getReportUser",
            PaymentMethodTypeTable: "PaymentMethod/getPaymentMethodTypeTableWithAll",
            OrderStatusTable: "Order/OrderStatusTableWithAllPayment",
            reportDatum: "Report/getReportDatum",
            UserTable: "User/getData",
        }),
		OptionUserTable: function() {
			return [{ UserID: 0, fname: "-- พนักงาน --",lname:"" }, ...this.UserTable]
        },
		SaleChannelTypeTable(){
			return [
				{id:1,name:"บริษัท"},
				{id:2,name:"ตัวแทน"},
			]
		},
		SaleChannelTypeTableWithAll(){
			return [{id:0,name:"-- ประเภทช่องทางการขาย -- "}].concat(this.SaleChannelTypeTable);
		},
        tableColumns: function() {
            return [
                {
                    prop: "Name",
                    label: this.$t("order_user"),
                    minWidth: 90,
                    sortable: true
                },
                {
                    prop: "BoSaleChannelName",
                    label: this.$t("sale_channel"),
                    minWidth: 90,
                    sortable: true
                },
                {
                    prop: "Cnt",
                    label: this.$t("order_amount"),
                    minWidth: 100,
                    sortable: true
                },
                {
                    prop: "Amount",
                    label: this.$t("payment_amount"),
                    minWidth: 100,
                    sortable: true
                }
            ];
        }
    },
    data() {
        return {
            propsToSearch: ["Name"],
            selectedRows: [],
            SearchData: "",
            startDate: "",
            endDate: "",
            paymentMethodType: 0,
            orderStatus: 0,
			saleChannelType:0,
			userId:0,
        };
    },
    mounted() {
        this.listUser();
        this.startDate = moment()
            .add(-30, "days")
            .format("YYYY-MM-DD");
        this.endDate = moment().format("YYYY-MM-DD");
        this.handleSearch();
    },
    methods: {
        ...mapActions({
            listData: "Report/listReportUser",
            listUser: "User/listData",
        }),
        async handleSearch() {
            let params = {
                time_from: this.startDate,
                time_to: this.endDate,
                payment_method_type: this.paymentMethodType,
				order_status: this.orderStatus == 0 ? [111,112,114,121,122,130] : [this.orderStatus] ,
				sale_channel_type_id : this.saleChannelType,
				user_id : this.userId
            };
            await this.listData(params);
			this.sortChange({prop:"Cnt",order:"desc"})

			
        },
        handleExport() {
            const csvString = [
                ["พนักงาน","ช่องทางการขาย", "จำนวนรายการสั่งซื้อ", "จำนวนเงิน"],
                ...this.tableData.map(item => [
                    item.Name,
                    item.BoSaleChannelName,
                    item.Cnt,
                    item.Amount
                ])
            ]
                .map(e => e.join(","))
                .join("\n");

            let csvContent = "data:text/csv;charset=utf-8,\ufeff" + csvString;
            var encodedUri = encodeURI(csvContent);
            var link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("download", "report_user.csv");
            document.body.appendChild(link); // Required for FF

            link.click();
        },
		async handleDownloadXLSX(index,row){

			let dataExport = this.tableData.map((item)=>{
				return {
                    "พนักงาน" : item.Name,
                    "ช่องทางการขาย" : item.BoSaleChannelName,
                    "จำนวนรายการสั่งซื้อ" : item.Cnt,
                    "จำนวนเงิน" : item.Amount
                }
			})

			const dataWS = utils.json_to_sheet(dataExport)
			const wb = utils.book_new()
			utils.book_append_sheet(wb, dataWS)
			writeFile(wb,`user_${this.startDate}_${ this.endDate}.xlsx`)

		},

        handleDetail(index, row) {
            // this.$router.push("/wms/historydetail/" + row.ID);
            window.open("/#/wms/historydetail/" + row.ID);
        },
        selectionChange(selectedRows) {
            this.selectedRows = selectedRows;
        }
    }
};
</script>
<style>
.no-border-card .card-footer {
    border-top: 0;
}
</style>
